import { RequestBuilder } from "../requestBuilder";
import z from "zod";
import { CreateViewInputSchema, UpdateViewInputSchema, ViewIdParamsSchema, ViewsSyncSchema } from "./viewClient.types";
import { ViewSchema } from "@storytell/types";

export const ViewsSyncRequestConfig = new RequestBuilder({
  path: () => "/views-sync",
  responseSchema: ViewsSyncSchema,
});

export const GetAllViewsRequestConfig = new RequestBuilder({
  path: () => "/views",
  responseSchema: z.array(ViewSchema),
});

export const CreateViewRequestConfig = new RequestBuilder({
  path: () => "/views",
  responseSchema: ViewSchema,
  bodySchema: CreateViewInputSchema,
}).withMethod("POST");

export const GetViewByIdRequestConfig = new RequestBuilder({
  paramsSchema: ViewIdParamsSchema,
  path: (params) => `/views/${params.id}`,
  responseSchema: ViewSchema,
});

export const DeleteViewRequestConfig = new RequestBuilder({
  paramsSchema: ViewIdParamsSchema,
  path: (params) => `/views/${params.id}`,
})
  .withMethod("DELETE")
  .withContentType(undefined);

export const UpdateViewRequestConfig = new RequestBuilder({
  paramsSchema: ViewIdParamsSchema,
  path: ({ id }) => `/views/${id}`,
  responseSchema: ViewSchema,
  bodySchema: UpdateViewInputSchema,
}).withMethod("POST");
